import React from 'react';
import { ArticleHeader, Section, Stack } from '@belong/ui-components';
import useRuntime from '@belong/providers/runtime';
import { ISectionArticleHeader } from './model';

const FULLWIDTH_BREAKPOINTS = ['xs', 'sm'];

export const SectionArticleHeader: React.FC<ISectionArticleHeader> = props => {
  const { currentBreakpoint } = useRuntime();
  const { id, identifier, sectionStyles, ...componentProps } = props;
  const isFullWidth = FULLWIDTH_BREAKPOINTS.includes(currentBreakpoint) || !!componentProps.image;
  const hasDarkBackground = sectionStyles?.hasBackground?.toLowerCase() === 'black';

  return (
    <Section
      data-contentid={id}
      data-identifier={identifier}
      data-testid="section-article-header"
      isFullWidth={isFullWidth}
      isPadded={false}
      {...sectionStyles}
    >
      <Stack>
        <ArticleHeader {...componentProps} hasDarkBackground={hasDarkBackground} />
      </Stack>
    </Section>
  );
};

export default SectionArticleHeader;
